/* eslint-disable no-unused-vars */
import * as d3 from 'd3';
import _ from 'lodash';
import * as topojson from 'topojson-client';
import createBase from '../utils/d3-base';
import { intcomma } from 'journalize';
import {
  highways,
  cities,
  add_legend_for_gray,
  rate_perResidents,
  relocateTooltip,
} from '../utils/map-utils';
import * as ss from 'simple-statistics';
import loadAssetURL from '../utils/load-asset-url';

const partners = window.location.search;
const isPartners = partners ? true : false;
const TT_logo_present = loadAssetURL('TT-logo-present');

import topology from 'Assets/geography/texas_counties_roads.json';
import data from '../../../data/map/tx_covid_map.json';

const container = d3.select('#tx-rates-map');

const getFrameWidth = () => container.node().offsetWidth;

// a helper function to clear the container of its contents
const clearContainer = () => container.html('');

// breakpoint for mobile
let breakPoint = 544;

// Toggle buttons

// let btnContainer = document.querySelector('#btnGroup');
// let btns = btnContainer.getElementsByClassName('button');

// for (var t = 0; t < btns.length; t++) {
//   btns[t].addEventListener('click', function (event) {
//     var currentParent = document.querySelector('#btnGroup');
//     var current = currentParent.getElementsByClassName('active');
//     current[0].className = current[0].className.replace(' active', '');
//     this.className += ' active';
//     defVal = this.value;
//     let promises = [topology, defVal];
//     Promise.all(promises).then(ready);
//   });
// }

// sets geo stuff for projection
const geoPath = d3.geoPath();

const geoIdentity = d3.geoIdentity().reflectY(true);

// establish color bucket breakdown
let color = d3
  .scaleQuantile()
  .range([
    '#ffffe0',
    '#FFF5B2',
    '#FDDE85',
    '#FDBB45',
    '#FDA23E',
    '#F2691D',
    '#DB3F2A',
    '#A52C20',
    '#6C1D1C',
  ]);

const latest_date = data['latest_date'];

const cases = data[latest_date]['cases'];

const casesData = d3.map(),
  rateData = d3.map(),
  deathData = d3.map();

// sets the data for cases, rate per 1000 and deaths
cases.forEach(d =>
  rateData.set(d.id, rate_perResidents(+d.cases, +d.population, 1000))
);
cases.forEach(d => casesData.set(d.id, +d.cases));
cases.forEach(d => deathData.set(d.id, +d.deaths));

// Make object into array so we can find the domain of data for color scale
let dataArray = Object.keys(rateData).map(key => rateData[key]);

export default function renderRateMap() {
  clearContainer();

  const frameWidth = getFrameWidth(); // calcuates the width on each render

  // Establishes as isMobile function

  const isMobile = frameWidth < breakPoint;

  // uses `./utils/d3-base` to set up a bunch of conventional d3 stuff

  const map = createBase({
    container, // the chart container
    height: isMobile ? frameWidth + (isPartners ? 120 : 70) : 600, // mobile height
  });

  // Creates the svg for the map

  const svg = map.g.append('g').attr('class', 'g_rate_map');

  let promises = [topology];

  Promise.all(promises).then(ready);

  function ready([shapefiles]) {
    // Creates title and map base for the rate map

    const state = topojson.merge(
        shapefiles,
        shapefiles.objects.counties.geometries
      ),
      counties = topojson.feature(shapefiles, shapefiles.objects.counties),
      texas_highways = topojson.feature(shapefiles, shapefiles.objects.roads),
      major_cities = topojson.feature(shapefiles, shapefiles.objects.places);

    // Finding ckmeans Thresholds for scale, an alternative to the usual scale

    // More info here: https://observablehq.com/@d3/quantile-quantize-and-threshold-scales

    // https://medium.com/@dschnr/using-clustering-to-create-a-new-d3-js-color-scale-dec4ccd639d2

    const numberOfClasses = color.range().length - 1;

    let ckmeansThresholds = ss.ckmeans(dataArray, 3).map(v => v.pop());
    let ckmeansBreaks = ss
      .ckmeans(dataArray, numberOfClasses)
      .map(v => v.pop());

    // get the extent of data to find a range for domain
    let dataRange = d3.extent(dataArray, d => d);

    let x_legend = d3
      .scaleLinear()
      .rangeRound([
        map.width * (isMobile ? 0.1 : 0.58),
        map.width * (isMobile ? 0.9 : 0.825),
      ]);

    // Establish the domain
    color.domain(ckmeansBreaks);
    x_legend.domain(ckmeansBreaks);

    const projection = geoIdentity.fitExtent(
      [
        [0, isMobile ? 75 : 0],
        [map.width, map.height],
      ],
      state
    );

    const path = geoPath.projection(projection);

    // Adding Texas county shapefile
    const counties_shape = svg
      .selectAll('g')
      .data(counties.features)
      .enter()
      .append('path')
      .attr('class', 'counties')
      .attr('fill', d =>
        (rateData.get(d.id)
        ? (d.cases = rateData.get(d.id))
        : (d.cases = 0))
          ? color(d.cases)
          : '#e8e8e8'
      )
      .attr('stroke', 'rgba(255, 255, 255, .6)')
      .attr('d', path);

    // Adds highways (the order of this is very important)
    highways(svg, texas_highways, path);

    // Add cities
    cities(svg, major_cities, path);

    const tooltip = container
      .append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0);

    counties_shape.on('mouseover', MouseOver).on('mouseout', MouseOut);

    function MouseOver(d, i) {
      const active_county = svg
        .append('path')
        .datum(d)
        .attr('d', path)
        .classed('active_county', true);

      const rate = rateData.get(d.id),
        deaths = deathData.get(d.id),
        cases = casesData.get(d.id);

      var tooltip_div = `<div class='county-title'>${
        d.properties.name
      } County</div><div class='county-data'>Cases per 1,000: ${
        rate ? rate.toFixed(2) : 0
      }</div><table class="dv-table"><tbody><tr><td class='tooltip_header'>
      Cases
     </td><td class="number text-right">
     ${cases ? intcomma(cases) : 0}
    </td>
           </tr><tr><td class='tooltip_header'>
           Deaths
          </td><td class="number text-right">
          ${cases ? intcomma(deaths) : 0}
         </td></tr><tbody></table>`;

      tooltip.style('opacity', 0.9).html(tooltip_div);

      relocateTooltip(
        tooltip,
        d3.event.pageX,
        d3.event.pageY,
        d3.event.screenY
      );
    }

    function MouseOut(d) {
      // Add interactivity
      tooltip.style('opacity', 0);
      d3.selectAll('.active_county').remove();
    }

    const legend = svg
      .append('g')
      .attr('class', 'legend')
      .attr('transform', `translate(${isMobile ? 0 : map.width / -50},${0})`);

    const rate_legend = legend
      .append('g')
      .attr('class', 'rate_legend')
      .attr('transform', `translate(${isMobile ? 0 : 0},${0})`);

    // Creates legend based on rate data

    const legend_rect_width =
      (x_legend.range()[1] - x_legend.range()[0]) / numberOfClasses;
    
    legend
      .append('g')
      .attr('class', 'tick')
      .append('g')
      .attr('transform', `translate(${x_legend.range()[0]},-8)`)
      .append('text')
      .text('Cases per 1,000 residents')

    rate_legend
      .selectAll('rect')
      .data(
        color.range().map(function(d) {
          d = color.invertExtent(d);
          if (d[0] == null) d[0] = 0;
          return d;
        })
      )
      .enter()
      .append('rect')
      .attr('height', 10)
      .attr('x', (d, i) => x_legend.range()[0] + i * legend_rect_width)
      .attr('width', (d, i) => legend_rect_width + 2)
      .attr('fill', d => color(d[0]));

    rate_legend
      .call(
        d3
          .axisBottom(x_legend)
          .tickSize(15)
          .tickFormat((d, i) =>
            i
              ? ckmeansBreaks[numberOfClasses - 1].toFixed(2) + '+'
              : dataRange[0].toFixed(2)
          )
          .tickValues(color.domain())
      )
      .select('.domain')
      .remove();

    // This adds the "No reported cases" gray box below the legend
    add_legend_for_gray(legend, 'rate', x_legend, isMobile);
  }

  const partners_img_width = map.width * (isMobile ? 1 : 0.5);
  const partners_img_height = partners_img_width / 13.3;

  if (isPartners) {
    const partner_link = svg
      .append('a')
      .attr('xlink:href', 'https://www.texastribune.org/')
      .attr('target', '_parent')
      .attr('rel', 'noopener noreferrer');

    partner_link
      .append('svg:image')
      .attr('alt', 'Coronavirus tracker presented by The Texas Tribune')
      .attr('x', -20)
      .attr('y', map.height - partners_img_height / 2)
      .attr(
        'width',
        frameWidth > 800 ? partners_img_width * 0.7 : partners_img_width
      )
      .attr('height', partners_img_height)
      .attr('xlink:href', TT_logo_present);
  }
}

// function resize() {
//   // code executed on window resize
//   let frameWidth = getFrameWidth(),
//     frameHeight;

//   if (frameWidth < breakPoint) {
//     frameHeight = 475;
//   } else {
//     frameHeight = 600;
//   }

//   let chartWidth = frameWidth,
//     chartHeight = frameHeight;
//   let promises = [topology];

// }

// // call resize on load
// resize();
// window.addEventListener('resize', _.debounce(resize, 200));
